module.exports = __webpack_public_path__ + "static/media/8.0b2c0982.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shoes/8.png
// module id = 1544
// module chunks = 0